import { SwiperOptions } from 'swiper/types'

export const options: SwiperOptions = {
  slidesPerView: 1,
  spaceBetween: 20,
  allowTouchMove: true,
  loop: true,
  injectStyles: [
    `.swiper-button-next, .swiper-button-prev {
      width: 24px !important;
      height: 24px !important;
      color: #ffffff !important;
      border-radius: 100%;
      top: 0;
      bottom: 0;
      margin: auto;
    }

    .swiper-button-next svg, .swiper-button-prev svg {
      width: 80% !important;
      height: 80% !important;
    } 
    
    .swiper-button-next {
      right: 0 !important;
    }

    .swiper-button-next svg {
      right: 2px;
    }
    
    .swiper-button-prev {
      left: 0 !important;
    }

    .swiper-button-prev svg {
      left: 2px;
    }`
  ]
}
